import { render } from "./datiCliente.vue?vue&type=template&id=78f15a66&ts=true"
import script from "./datiCliente.vue?vue&type=script&lang=ts"
export * from "./datiCliente.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__